module.exports = __webpack_public_path__ + "080d514b68c69ff142c33f6ffdb1cbcc.svg";